import {IContentByRoleParams, IPagination, ITypePage} from "./content.interfaces";
import {IGenreContent} from "../user";
import {buildAllContentQueryParams, buildContentQueryParams, buildPageQueryParams, buildPageContentQueryParams, getIsKids} from "./content.helpers";

function getServicePath(params: ITypePage) {
    const isKids = getIsKids(params.role);
    return isKids ? `${params.page}_KIDS` : params.page;
}

export const contentServices = {
    fetchCategoriesRequest: (params: ITypePage) => {
        const path = getServicePath(params);
        const queryParams = buildPageQueryParams(params);
        return {
            url: `/page/${params.type || "genre_list"}/${path}/${queryParams ? `?${queryParams}` : ""}`
        }
    },
    // getPage: (params: ITypePage) => {
    //     const path = getServicePath(params)
    //     console.log("path", path);
    //     return {
    //         url: `/page/by_name/${path}`
    //     }
    // },
    getPage: (params: ITypePage) => {
        const path = getServicePath(params);
        const queryParams = buildPageQueryParams(params);
        return {
            url: `/page/by_name/${path}/${queryParams ? `?${queryParams}` : ""}`
        }
    },
    getPageResults: (params: ITypePage) => {
        const path = getServicePath(params)
        const queryParams = new URLSearchParams();
        if (params.page_number !== undefined) {
            queryParams.append("page", String(params.page_number));
        }
        if (params.rehydrated_pagination !== undefined) {
            queryParams.append("rehydrated-pagination", String(params.rehydrated_pagination));
        }
        if (params.profile_id) {
            queryParams.append("profile_id", String(params.profile_id));
        }
        const queryString = queryParams.toString();
        const url = `/page/by_name/${path}/${queryString ? `?${queryString}` : ""}`;
        return { url };
    },
    getAllContent: (params: ITypePage) => {
        const path = getServicePath(params);
        const queryParams = buildAllContentQueryParams(params);
        return {
            url: `/content/content/all/${path}/?${queryParams}`
        }
    },
    getPageContent: (params: ITypePage) => {
        const queryParams = buildPageContentQueryParams(params);
        return {
            url: `/content/content/category-id/${params.content_id}/?${queryParams}`
        }
    },
    getNearbyEvents: (params: ITypePage) => {
        const queryParams = new URLSearchParams({
            page: String(params.page_number ?? 1),
            "rehydrated-pagination": String(params.rehydrated_pagination ?? true),
        });

        if (params.status) {
            queryParams.append("status", params.status);
        }

        if (params.search) {
            queryParams.append("search", params.search);
        }

        return {
            url: `/content/content/nearby_events/?${queryParams.toString()}`
        }
    },
    // getOnlinePageContent: (params: ITypePage) => {
    //     return {
    //         url: `/content/content/category-id/${params.content_id}?rehydrated-pagination=true&page=1&${params.profile_id}`
    //     }
    // },

    getGenreContent: (params: IGenreContent) => {
        const isKids = getIsKids(params.role);
        return {
            url: `/content/content/category-id/${params.id}/?profile_id=${params.profileID}&rehydrated-pagination=true&page=1&video=false&is_kids=${isKids}`
        }
    },
    getContentDetails: (params: IContentByRoleParams) => {
        const queryParams = buildContentQueryParams(params.role, params.profile_id ?? null);
        return {
            url: `/content/content/${params.id}/?${queryParams}`
        }
    },
    getRelatedContent: (params: IContentByRoleParams) => {
        const queryParams = buildContentQueryParams(params.role, params.profile_id ?? null);
        return {
            url: `/content/content/${params.id}/related_content/?${queryParams}`
        }
    },
    getSearchPage: (params: IPagination) => {
        const {page, query, role} = params;
        const isKids = getIsKids(role);
        const searchQuery = query ? `search=${query}&` : "";
        return {
            url: `/content/content/?${searchQuery}page=${page}&is_kids=${isKids}`
        };
    }

}
